<template>
  <div class="distributor-box back-fff p20">
    <!--返回按钮-->
    <div class="go-back" @click="goBackBtn">
      <Icon class="back-icon" type="ios-arrow-back"/>
      <span class="back-txt">{{ $t('key1002627') }}</span>
    </div>
    <div class="modifyMobile_box">
      <Steps :current="current">
        <Step :title="$t('key1005485')"></Step>
        <Step :title="$t('key1005532')"></Step>
        <Step :title="$t('key1003254')"></Step>
      </Steps>
      <Form ref="mobileForm" :rules="mobileRuleValidate" :model="mobileForm"
        class="mobileForm" :label-width="labelWidth" @submit.native.prevent>
        <Row style="width: 90%;">
          <!--验证身份-->
          <Col :xxl="oneItemCol" v-if="current === 0">
            <Form-item :label="$t('key1000068')" prop="emailOrMobile">
              <Input :placeholder="$t('key1003150')" clearable v-model.trim="mobileForm.emailOrMobile"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" v-if="current === 0">
            <Form-item :label="$t('key1005487')" prop="verificationCode">
              <div class="options">
                <Input :placeholder="$t('key1001004')" clearable v-model.trim="mobileForm.verificationCode"></Input>
                <img class="verification_img ml20" :alt="$t('key1001003')" width="110" height="40" :src="captchaImage" @click="getCaptcha"/>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" v-if="current === 0">
            <Form-item :label="$t('key1005491')" prop="code">
              <div class="options">
                <Input :placeholder="$t('key1005492')" clearable v-model.trim="mobileForm.code"></Input>
                <Button type="primary" class="verification_btn" :class="languagesVal === 'zh-CN' ? 'set_verification_btn' : ''"
                  @click="sendVerificationCode" :disabled="talgCode">{{ codeText }}</Button>
              </div>
            </Form-item>
          </Col>
          <!--设置新手机号-->
          <Col :xxl="oneItemCol" v-if="current === 1">
            <Form-item :label="$t('key1005533')" prop="emailOrMobile">
              <Input clearable :placeholder="$t('key1005534')" v-model.trim="mobileForm.emailOrMobile">
                <Select slot="prepend" v-model="mobileForm.mobileCountryCode" filterable transfer class="reset_select_input">
                  <Option v-for="(item, index) in countrysData" :value="item.areaCode" :key="index">{{ item.areaCodeName }}</Option>
                </Select>
              </Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" v-if="current === 1">
            <Form-item :label="$t('key1005488')" prop="code">
              <div class="options">
                <Input :placeholder="$t('key1005489')" clearable v-model.trim="mobileForm.code"></Input>
                <Button type="primary" class="verification_btn" :class="languagesVal === 'zh-CN' ? 'set_verification_btn' : ''"
                  @click="sendVerificationCode" :disabled="talgCode">{{ codeText }}</Button>
              </div>
            </Form-item>
          </Col>
          <!--设置成功-->
          <Col :xxl="oneItemCol" v-if="current === 2">
            <div class="setting_box">
              <i class="iconfont setting-icon">&#xe614;</i>
              <p class="txt">{{ $t('key1003254') }}</p>
            </div>
          </Col>
          <Col :xxl="oneItemCol" v-if="current === 0">
            <div class="next_step" @click="nextStepBtn">{{ $t('key1002560') }}</div>
          </Col>
          <Col :xxl="oneItemCol" v-if="current === 1">
            <div class="next_step" @click="nextStepBtn">{{ $t('key1005493') }} {{ $t('key1005494') }}</div>
          </Col>
        </Row>
      </Form>
    </div>
  </div>
</template>

<style lang="less" scoped>
.modifyMobile_box {
  width: 700px;
  margin: 30px auto 0;
  height: 494px;

  .mobileForm {
    width: 100%;
    margin-top: 60px;

    .options {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    /deep/ .ivu-input {
      height: 40px;
      line-height: 40px;
      width: 100%;
    }

    .verification_img {
      display: inline-block;
      cursor: pointer;
      width: 110px;
      height: 40px;
    }

    .verification_btn {
      width: 110px;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      box-sizing: border-box;
      margin-left: 20px;
    }

    .set_verification_btn {
      width: 190px;
    }

    .next_step {
      margin: 40px auto 20px;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #FD5425;
      border-radius: 2px;
      box-sizing: border-box;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }

    .setting_box {
      margin: 40px auto 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .setting-icon {
        color: #28BD6E;
        font-size: 38px;
      }

      .txt {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bolder;
        color: #000000;
      }
    }
  }

  /deep/ .reset_select_input {
    width: 120px;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;

    .ivu-select-selection {
      height: 40px;
    }
  }

  /deep/ .ivu-input-group-prepend {
    background-color: transparent;
  }
}
</style>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getAllCountrysData} from "@/utils/common";

export default {
  name: "modifyMobile",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      oneItemCol: { // 划分为一等分
        span: 24
      },
      current: 0,
      talgCode: false,
      mobileForm: {
        emailOrMobile: '',
        code: '',
        verificationCode: '',
        mobileCountryCode: '86'
      },
      codeText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988'),
      mobileRuleValidate: {
        emailOrMobile: [
          {
            validator: v.validateEmail(),
            required: true,
            trigger: 'blur'
          }
        ],
        verificationCode: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005478'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000990'),
            trigger: 'blur'
          }
        ]
      },
      captchaImage: '',
      uid: '',
      timeStop: null,
      countrysData: []
    };
  },
  created() {
    getAllCountrysData('en').then(data => {
      this.countrysData = data;
      // 默认为中国手机号 +86
      this.mobileForm.mobileCountryCode = '86';
    });
    this.getCaptcha();
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 返回列表
    goBackBtn() {
      this.$router.push('/securityInformation');
    },

    // 下一步
    nextStepBtn() {
      let v = this;
      // 校验身份验证
      let query = {
        code: v.mobileForm.code,
        emailOrMobile: v.mobileForm.emailOrMobile,
        messageType: v.mobileForm.mobileCountryCode === '86' ? 3 : 16, // 类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录  16 海外-绑定手机
      };
      if (v.current === 0) {
        v.$refs['mobileForm'].validate((valid) => {
          if (valid) {
            v.axios.post(api.distributor_post_ymsUserSetting_validVerificationCode, query).then(response => {
              if (response.data.code === 0) {
                v.current += 1;
                v.$refs['mobileForm'].resetFields();
                clearInterval(v.timeStop);
                v.talgCode = false;
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
              }
            });
          }
        });
      }
      // 设置新手机
      else if (v.current === 1) {
        query.mobileCountryCode = v.mobileForm.mobileCountryCode;
        v.$refs.mobileForm.validateField("emailOrMobile", (error) => {
          if (!error) {
            v.$refs.mobileForm.validateField("code", (error) => {
              if (!error) {
                v.axios.post(api.distributor_post_ymsUserSetting_validVerificationCode, query).then(response => {
                  if (response.data.code === 0) {
                    v.axios.post(api.post_ymsDistributorMerchant_updateMobile + '?mobile=' + v.mobileForm.emailOrMobile).then(response => {
                      if (response.data.code === 0) {
                        v.current += 1;
                        v.$refs['mobileForm'].resetFields();
                        clearInterval(v.timeStop);
                        v.talgCode = false;
                        v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    },
    // 发送验证码
    sendVerificationCode() {
      let v = this;
      let talg = false;
      let isMob = v.$regular.isPhone;
      let isMailbox = v.$regular.isMailbox;
      let url = '';
      let query = {
        code: v.mobileForm.verificationCode, // 图片的验证码
        messageType: 3, //  类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录  mobile
        uid: v.uid
      };
      if (v.current === 0) {
        if (v.mobileForm.verificationCode && v.mobileForm.emailOrMobile) {
          if (isMailbox.test(v.mobileForm.emailOrMobile)) {
            talg = true;
            query.email = v.mobileForm.emailOrMobile;
            query.isvalid = 1;
            query.userId = v.userInfo.userId;
            query.isSelf = 1;
            url = api.distributor_post_ymsUserSetting_sendEmailVerificationCode;
          } else {
            Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005481'));
            return false;
          }
        } else {
          Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005529'));
          return false;
        }
      } else if (v.current === 1) {
        if (v.mobileForm.emailOrMobile) {
          if (isMob.test(v.mobileForm.emailOrMobile)) {
            talg = true;
            query.mobile = v.mobileForm.emailOrMobile;
            query.isvalid = 0;
            query.mobileCountryCode = v.mobileForm.mobileCountryCode;
            url = api.distributor_post_ymsUserSetting_sendMobileVerificationCode;
          } else {
            Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005530'));
            return false;
          }
        } else {
          Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005531'));
          return false;
        }
      }
      if (talg) {
        v.current === 1 ? delete query.code : null;
        v.axios.post(url, query).then(response => {
          if (response.data.code === 0) {
            let time = 60;
            v.timeStop = setInterval(() => {
              time--;
              if (time > 0) {
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000995') + time + 'S';
                v.talgCode = true;
              } else {
                time = 60;
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
                clearInterval(v.timeStop); //清除定时器
                v.talgCode = false;
              }
            }, 1000);
            Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005483'));
          } else {
            v.talgCode = false;
          }
        });
      }
    },
    // 校验邮箱、手机号
    validateEmail() {
      let v = this;
      let isMailbox = v.$regular.isMailbox;
      let isMob = v.$regular.isPhone;
      return function (rule, value, callback) {
        if (v.current === 0) {
          if (!value) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005183')));
          } else if (!isMailbox.test(value)) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005484')));
          } else {
            callback();
          }
        } else if (v.current === 1) {
          if (!value) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001158')));
          } else if (!isMob.test(value)) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000148')));
          } else {
            callback();
          }
        }
      };
    },

    // 获取图片验证码
    getCaptcha() {
      this.axios.get(api.distributor_get_captcha).then((response) => {
        this.captchaImage = 'data:image/png;base64,' + response.data.datas.base64ImageCode;
        this.uid = response.data.datas.uid;
      });
    }
  }
};
</script>
